import React from 'react';

import Emoji from '../Emoji';

import './footer.css';

const Footer = () => (
    <footer>
        <p>
            Created with <Emoji symbol="😷" label="face-with-medical-mask"/> by <a href='https://vk.com/marksmirnov13'>Mark Smirnov</a>
        </p>
    </footer>
);

export default Footer;
